import { type SvgIconProps } from '@common/components/svgs/props';

function IconClose(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Close"
    >
      <path
        d="M13.4142 12L19.4852 5.92892L18.071 4.51471L12 10.5858L5.92891 4.51471L4.5147 5.92892L10.5857 12L4.51465 18.0711L5.92886 19.4853L12 13.4142L18.071 19.4853L19.4853 18.0711L13.4142 12Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconClose.displayName = 'Close';

export default IconClose;
